jQuery(function($) {

  var subnavToggle = function() {
    $('.sidebar').toggleClass('subnav--active');
    $('.subnav__mobile').toggleClass('subnav__mobile--active');
  }

  $('.subnav__mobile__icon').on('click', function() {
    subnavToggle();
  });

});
